export const GET_COMMON_DASHBOARD = 'GET_COMMON_DASHBOARD';
export const SET_COMMON_DASHBOARD_APPS = 'SET_COMMON_DASHBOARD_APPS';
export const ADD_APP_FAV = 'ADD_APP_FAV';
export const REMOVE_APP_FAV = 'REMOVE_APP_FAV';
export const SET_ADD_APP_FAV = 'SET_ADD_APP_FAV';
export const SET_LOADING = 'SET_LOADING';
export const GET_NEWS_AND_ANNOUNCEMENT = 'GET_NEWS_AND_ANNOUNCEMENT'
export const SET_NEWS_AND_ANNOUNCEMENT = 'SET_NEWS_AND_ANNOUNCEMENT'
